export const dietFields = {
    name: 'name',
};
